import {Injectable} from '@angular/core';

@Injectable()
export class DESCMainService {
    // this is the primary working service
    // it holds all the values for component display as well as provides the
    // sample computation methods

    //  values from sampleselect component
    public activeExp: string;
    public activeSite: string;
    public activeHole: string;
    public currentHoleList: Array<string>;

    constructor() {
    }

}
